import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: inline-block;\n    cursor: pointer;\n\n    ", "\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { marginAttributes } from '../../../system';
import { getPropsBlocker } from '../../../utils';
var propertyList = {
  tag: true,
  useMessageColor: true
};

var Wrapper = function Wrapper(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return children(className);
};

export var MessageActionRoot = styled(Wrapper).withConfig(getPropsBlocker(propertyList))(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.componentOverrides.MessageAction.Root.base;
}, marginAttributes);